import { HTTP } from '../../utils/http';

export const ActivitiesService = {
    getActivitiesByType(schoolId, activityType) {
        return HTTP.get(`/reports/school/${schoolId}/activities?activityType=${activityType}`);
    },

    getClassesByDate(schoolId, date, timezone) {
        return HTTP.get(`/schools/${schoolId}/classes/dashboard?filterDate=${date}&timeZone=${timezone}`);
    },

    getCampsByDate(schoolId, date, timezone) {
        return HTTP.get(`/schools/${schoolId}/camps/dashboard?filterDate=${date}&timeZone=${timezone}`);
    },

    getAfterCareByDate(schoolId, date, timezone) {
        return HTTP.get(`/schools/${schoolId}/aftercare/dashboard?filterDate=${date}&timeZone=${timezone}`);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/pages/activities.service.js